import * as React from 'react'

import Svg, { Path, Rect } from 'react-native-svg'

import { IconProps } from '../icons'

const ManWithShortHairProfile = ({
  size = 36,
  color = '#596379',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} fill="#fff" />
    <Path
      d="M12.555 16.393c.781 2.56 2.788 5.222 5.495 5.222 2.707 0 4.718-2.661 5.495-5.222.668-.232 1.226-.9 1.444-1.763.3-1.185-.14-2.284-.994-2.615a4.03 4.03 0 0 0 .118-.968c0-2.81-2.802-5.081-6.258-5.081s-6.267 2.275-6.267 5.081c0 .4.063.79.168 1.163-.618.468-.9 1.412-.645 2.425.218.858.776 1.526 1.444 1.758Zm-.418-3.266c.091-.15.21-.25.359-.29a.624.624 0 0 1 .172-.005l.432.041.064-.427c.131-.89.408-1.69.799-2.37.73.822 2.184 1.38 3.86 1.38 1.894 0 3.506-.713 4.1-1.712.5.75.855 1.662 1.009 2.702l.063.427.432-.04a.707.707 0 0 1 .172.004c.032.004.05.027.082.036.39.173.59.858.422 1.54-.172.694-.626 1.103-.985 1.149l-.3.04-.081.291c-.654 2.389-2.47 4.814-4.696 4.814-2.225 0-4.042-2.42-4.687-4.814l-.081-.29-.3-.041c-.359-.046-.813-.464-.986-1.15-.113-.49-.045-.985.15-1.285Z"
      fill={color}
    />
    <Path
      d="M23.386 19.562c-.581.99-1.253 1.83-2.148 2.28-1.84.94-3.206 1.703-3.206 1.703l-.005-.005v-.022l-.023.009-.022-.01v.023l-.005.005s-1.367-.759-3.206-1.703c-.89-.459-1.562-1.294-2.148-2.28C9.903 20.666 8 23.213 8 25.43v4.605h20V25.43c.01-2.217-1.894-4.76-4.614-5.868Z"
      fill={color}
    />
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} stroke="#D1D9E9" />
  </Svg>
)

export default ManWithShortHairProfile
